import type { SVGProps } from 'react';
const SvgLineStyle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#line_style_svg__a)">
      <path
        fill="currentColor"
        d="M3 16h5v-2H3v2Zm6.5 0h5v-2h-5v2Zm6.5 0h5v-2h-5v2ZM3 20h2v-2H3v2Zm4 0h2v-2H7v2Zm4 0h2v-2h-2v2Zm4 0h2v-2h-2v2Zm4 0h2v-2h-2v2ZM3 12h8v-2H3v2Zm10 0h8v-2h-8v2ZM3 4v4h18V4H3Z"
      />
    </g>
    <defs>
      <clipPath id="line_style_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLineStyle;
